import styled, { css } from 'styled-components';

export const SummaryCard = styled.div`
    display: flex;
    flex-direction: column;
    background-color: transparent;
    gap: 8px;
`;

export const Title = styled.p`
    font-weight: 500;
    font-style: medium;
    font-size: 16px;
    color: #616161;
`;
export const Result = styled.p`
    font-weight: 700;
    font-style: bold;
    font-size: 22px;
    color: #000000;
`;
export const Description = styled.p`
    font-weight: 600;
    font-size: 16px;

    ${(props) =>
        props.$state &&
        props.$state === 'increased' &&
        css`
            color: #ef2b2a;
        `}
    ${(props) =>
        props.$state &&
        props.$state === 'decreased' &&
        css`
            color: #0066ff;
        `}
    ${(props) =>
        props.$state &&
        props.$state === 'neutral' &&
        css`
            color: #757575;
        `}
`;
